import { AppImages } from "app/appImages";
import { GenericAbortSignal } from "axios";
import { AutoCompleteDataModel, AutoCompleteSuggestions, MprcAutoComplete } from "components/MprcAutoComplete";
import { IAutoCompleteProps } from "components/MprcAutoComplete/AutoComplete";
import { GroupType, GroupUsages } from "generated/CoreApi_v1";
import { isCanceledError, useCoreApi } from "providers/CoreApiProvider";

////////////////////////////////////////////////////////////////////////////

export type GroupAutoCompleteQueryParams = {
    pageNumber: number;
    pageSize: number;
    searchText?: string | null;
};

interface IProps {
    groupType?: GroupType;
    groupUsages?: GroupUsages;
    includeAllInternalExternalUserGroups?: boolean;
    exceptGroupIds?: string[];
    onGetDataCustom?: (data: GroupAutoCompleteQueryParams, signal: GenericAbortSignal | undefined) => Promise<AutoCompleteSuggestions<AutoCompleteDataModel>>;
}

type Props = IProps & Omit<IAutoCompleteProps, 'onGetSuggestions' | 'emptyThumbnail'>;

////////////////////////////////////////////////////////////////////////////

/**
 * Auto complete de grupos para cadastros
 * @param props
 */
export const GroupAutoComplete: React.FC<Props> = (props) => {

    const api = useCoreApi();

    const { groupType, groupUsages, exceptGroupIds, includeAllInternalExternalUserGroups, onError, onGetDataCustom } = props;

    ///
    const getSuggestions = (searchText: string, pageNumber: number, pageSize: number, trySelectedHistory: boolean, signal: GenericAbortSignal | undefined): Promise<AutoCompleteSuggestions<AutoCompleteDataModel>> => {
        searchText = searchText.toLowerCase();
        if (onGetDataCustom != undefined) {
            return onGetDataCustom({ pageNumber, pageSize, searchText }, signal);
        } else {
            return new Promise<AutoCompleteSuggestions<AutoCompleteDataModel>>((resolve) => {
                api.v1.suggestions.groups({
                    searchText: searchText,
                    groupType: groupType ?? null,
                    groupUsages: groupUsages ?? null,
                    exceptGroupIds: exceptGroupIds ?? [],
                    includeAllInternalExternalUserGroups: includeAllInternalExternalUserGroups ?? null,
                    pageNumber: pageNumber,
                    pageSize: pageSize,
                }, { signal })
                    .then(result => {
                        resolve({
                            items: result.data.items as AutoCompleteDataModel[],
                            totalRows: result.data.totalRows
                        });
                    })
                    .catch(error => {
                        if (!isCanceledError(error)) {
                            resolve({ items: [], totalRows: 0 });
                            if (onError) onError(error);
                        }
                    });
            });
        }
    };

    ////////////////////////////////////////////////////////////////////////////
    /// RENDER
    ////////////////////////////////////////////////////////////////////////////

    return (
        <MprcAutoComplete
            {...props}
            emptyThumbnail={AppImages.GroupThumbnail}
            onGetSuggestions={getSuggestions}
        />
    );
};
